import Game from '@api/models/Game';
import axios from '../axios';

import { ListUserGamesResponse } from '@controllers/GameController';

class GameController {
  public async listUserGames(): Promise<Game[]> {
    const response = await axios.get<ListUserGamesResponse>(`/api/user/game`);
    return response.data.games.map((game) => new Game(game));
  }
}

export default GameController;
